import Resource from './resource';
import Element from './element';
import { Resources, Attributes, Elements } from '../character/allValues';
import DiceAttribute from './diceAttribute';

export default class BaseAttributeCollection {
  public baseResources: Resource[] = [
    new Resource(Resources.lep),
    new Resource(Resources.aip),
    new Resource(Resources.ini),
    new Resource(Resources.ep),
    new Resource(Resources.wap),
    new Resource(Resources.myp),
    new Resource(Resources.hp),
  ];

  public baseDiceAttributes: DiceAttribute[] = [
    new DiceAttribute(Attributes.sta),
    new DiceAttribute(Attributes.kon),
    new DiceAttribute(Attributes.wen),
    new DiceAttribute(Attributes.ges),
    new DiceAttribute(Attributes.tap),
    new DiceAttribute(Attributes.sel),
    new DiceAttribute(Attributes.int),
    new DiceAttribute(Attributes.sch),
    new DiceAttribute(Attributes.wei),
    new DiceAttribute(Attributes.bil),
    new DiceAttribute(Attributes.cha),
    new DiceAttribute(Attributes.auf),
  ];

  public baseElements: Element[] = [
    new Element(Elements.feuer, false),
    new Element(Elements.wasser, false),
    new Element(Elements.erde, false),
    new Element(Elements.wind, false),
    new Element(Elements.licht, false),
    new Element(Elements.schatten, false),
    new Element(Elements.blut, false),
    new Element(Elements.nebel, false),

    // Schutzwerte
    new Element(Elements.feuer, true),
    new Element(Elements.wasser, true),
    new Element(Elements.erde, true),
    new Element(Elements.wind, true),
    new Element(Elements.licht, true),
    new Element(Elements.schatten, true),
    new Element(Elements.blut, true),
    new Element(Elements.nebel, true),
  ];
}
